module.exports = __webpack_public_path__ + "img/lock-locked.e9c172ee.svg";